import type { CfHeaderCookieType } from '@/middleware'
import { getCookie } from 'cookies-next/client'
import { logError } from '../log'

export const cfHeaderCookieName = 'cfHeader'

const defaultCfHeaderCookie: CfHeaderCookieType = {
  alpha2CountryCode: null,
  zipCode: '',
  city: '',
  latitude: '',
  longitude: '',
  region: '',
}

export const getCfHeaderCookie = () => {
  const cookie = getCookie(cfHeaderCookieName)

  if (!cookie) {
    return defaultCfHeaderCookie
  }

  try {
    const parsedCookie = JSON.parse(cookie) as CfHeaderCookieType

    return parsedCookie
  } catch (error) {
    logError('Failed to parse cfHeader cookie:', error)
    return defaultCfHeaderCookie
  }
}
